/**
 * Shared list-page search helpers — live filter across common fields.
 */

export function normalizeSearch(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

/**
 * Returns true if any of the given field values contain the query.
 * @param {unknown} query
 * @param {Array<unknown>} fields
 */
export function matchesSearch(query, fields = []) {
  const q = normalizeSearch(query);
  if (!q) return true;
  return fields.some((field) => String(field ?? "").toLowerCase().includes(q));
}

/**
 * Filter an array by searching across getter fields.
 * @template T
 * @param {T[]} rows
 * @param {unknown} query
 * @param {(row: T) => Array<unknown>} getFields
 */
export function filterBySearch(rows, query, getFields) {
  const list = Array.isArray(rows) ? rows : [];
  const q = normalizeSearch(query);
  if (!q) return list;
  return list.filter((row) => matchesSearch(q, getFields(row) || []));
}
